import { getStyle } from '@flowio/browser-helpers';
import parseFloat from './parseFloat';
export default function parseStyle(element, propertyName) {
  var style = getStyle(element, propertyName);
  return parseFloat(style, 0);
}